/* eslint-disable @angular-eslint/no-input-rename */
import { Component, Input, OnInit } from '@angular/core';
import { PdfReportTask } from '@services/sessions/pdfreport.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'pdf-task',
  templateUrl: './pdf-task.component.html',
  styleUrls: ['./pdf-task.component.scss'],
})
export class PdfTaskComponent implements OnInit {
  @Input() task: PdfReportTask<any>;
  @Input() first = false;
  @Input() second = false;
  @Input('open-subtasks') openSubTasks = false;
  @Input('open-subtasks-recursive') openSubTasksRecursive = false;

  open = false;

  ngOnInit() {
    this.open = this.openSubTasks;
  }

  toggle() {
    this.open = !this.open;
  }
}
